import { Directive, Host, Inject, Input, OnDestroy } from '@angular/core';
import { WorkflowItemId, WorkflowItemStatus } from '@api/projects/interfaces';
import { combineLatest, ReplaySubject, Subscription } from 'rxjs';
import { WorkflowService } from '@workflow/services/workflow.service';
import { map } from 'rxjs/operators';
import { getStatusTemplate } from '@app/components/cleanui/styles/config.defaults';
import { BADGE, IBadge, toStatus } from '@app/components/elements/badge.type';
import { IWorkflowItem } from '@interfaces/interfaces';

@Directive({
	selector: '[appWorkflowItemStatus]',
})
export class WorkflowItemStatusDirective implements OnDestroy {
	private readonly subscription = new Subscription();
	private readonly wfsId$ = new ReplaySubject<WorkflowItemId>(1);
	
	@Input('appWorkflowItemStatus')
	public set wfsId(id: WorkflowItemId) {
		this.wfsId$.next(id);
	}
	
	constructor(
		workflowService: WorkflowService,
		@Host() @Inject(BADGE) badge: IBadge,
	) {
		this.subscription.add(
			combineLatest([
				workflowService.workflow$,
				workflowService.workflowStatus$,
				this.wfsId$
			]).pipe(
				map(([workflow, workflowStatus, id]) => [
					workflow.items.find(item => item.id === id),
					workflowStatus?.status?.[id]
				]),
				map(([item, status]: [IWorkflowItem, WorkflowItemStatus]) => getStatusTemplate(item, status)),
				map(toStatus),
			).subscribe(status => badge.setStatus(status)),
		);
	}
	
	public ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	
}
